<template>
  <a-header :with-navigation="true" class="voting__header">
    <header-voting-button v-if="isVotingButtonVisible" slot="right-section" />
  </a-header>
</template>

<script>
import AHeader from '@/components/_layout/AHeader'
import HeaderVotingButton from 'sections/_voting/HeaderVotingButton'
import { ROUTE_NAME } from 'enums/routes'
import { IS_VOTING_CLOSED } from 'enums/main-route'

export default {
  name: 'AHeaderVoting',
  components: { HeaderVotingButton, AHeader },
  consts: {
    IS_VOTING_CLOSED
  },
  computed: {
    isVotingButtonVisible() {
      return this.$route.name !== ROUTE_NAME.THANK_YOU && !IS_VOTING_CLOSED
    }
  }
}
</script>

<style lang="scss" scoped></style>
